import type { SyntheticEvent } from 'react'
import { useIntl } from 'react-intl'

import { XMarkIcon } from '@gto/icons-react/solid/x-mark'
import { Button } from '@gto/ui/button'
import { IconButton } from '@gto/ui/icon-button'

export type AlertCloseButtonProps = {
  onClick: (event: SyntheticEvent) => void
  isSmScreen: boolean
}

export const AlertCloseButton = ({ onClick, isSmScreen, ...rest }: AlertCloseButtonProps) => {
  const { formatMessage } = useIntl()

  return isSmScreen ? (
    <Button
      aria-label="Close"
      color="secondary"
      size="large"
      variant="contained"
      style={{
        flex: '0 0 auto',
        order: 0,
      }}
      onClick={onClick}
      {...rest}
    >
      {formatMessage({ id: 'common.close' })}
    </Button>
  ) : (
    <IconButton
      aria-label="Close"
      size="small"
      style={{
        flex: '0 0 auto',
        order: 10,
      }}
      onClick={onClick}
      {...rest}
    >
      <XMarkIcon />
    </IconButton>
  )
}
